import React from 'react'
import './SoftwareDevContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaBullseye, FaSyncAlt, FaRobot, FaMobileAlt } from 'react-icons/fa'

export class SoftwareDevContent extends React.Component {
  render() {
    return (
      <div className="software-dev-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner consistently achieves the highest code challenge scores in
            competitive procurements across the Air Force, DHS, USCIS, and other
            agencies, earning head-to-head victories against major defense primes
            and leading technology firms.
          </div>
        </div>

        <section className="padding-large">
          <h2>Proven Performance</h2>
          <div className="row metrics-row">
            <div className="col-md-4">
              <div className="metric-card">
                <div className="number">4x</div>
                <div className="label">Agile Velocity vs. Incumbents</div>
                <div className="context">
                  When standing up new teams from scratch
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="metric-card">
                <div className="number">4x</div>
                <div className="label">Performance vs. Peer Vendors</div>
                <div className="context">
                  In multi-vendor competitive environments
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="metric-card">
                <div className="number">2.5x</div>
                <div className="label">Velocity with Incumbent Personnel</div>
                <div className="context">
                  Accelerating existing teams through best practices
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Technology Expertise</h2>
          <div className="row tech-columns">
            <div className="col-md-6">
              <div className="tech-category">
                <h3>Backend & Enterprise</h3>
                <ul>
                  <li>Java/J2EE (Spring Boot, JSP, Servlets)</li>
                  <li>.NET Framework & .NET Core</li>
                  <li>Python (Django, Flask, FastAPI)</li>
                  <li>Go for high-performance services</li>
                  <li>Node.js for JavaScript backends</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="tech-category">
                <h3>Frontend & Modern Architecture</h3>
                <ul>
                  <li>Angular, React, Vue.js</li>
                  <li>TypeScript for type-safe development</li>
                  <li>Containerized microservices</li>
                  <li>RESTful & GraphQL APIs</li>
                  <li>Progressive Web Applications</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Development Approach</h2>
          <div className="approach-grid">
            <div className="approach-item">
              <div className="icon"><FaBullseye /></div>
              <div className="content">
                <h3>Agile Sprints</h3>
                <p>
                  Organized development into functional sprints delivering working
                  software demonstrated to stakeholders at completion
                </p>
              </div>
            </div>
            <div className="approach-item">
              <div className="icon"><FaSyncAlt /></div>
              <div className="content">
                <h3>Continuous Integration</h3>
                <p>
                  All development flows through hardened CI/CD pipelines with
                  automated security scans, static analysis, and SBOM generation
                </p>
              </div>
            </div>
            <div className="approach-item">
              <div className="icon"><FaRobot /></div>
              <div className="content">
                <h3>AI-Accelerated Development</h3>
                <p>
                  Leverage AI and LLMs (where permitted) to accelerate testing,
                  documentation, code generation, and code analysis
                </p>
              </div>
            </div>
            <div className="approach-item">
              <div className="icon"><FaMobileAlt /></div>
              <div className="content">
                <h3>Offline-First Architecture</h3>
                <p>
                  For shipboard disconnected environments: intelligent edge
                  caching, local transaction queuing, automatic synchronization
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Quality & Security Built-In</h2>
          <div className="row quality-features">
            <div className="col-md-6">
              <div className="quality-block">
                <h3>Automated Testing</h3>
                <p>
                  Comprehensive unit, integration, and end-to-end testing with
                  automated regression suites ensuring reliability across releases.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="quality-block">
                <h3>Static Code Analysis</h3>
                <p>
                  Automated scanning with SonarQube, Fortify, and other tools to
                  identify vulnerabilities, code smells, and technical debt early.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="quality-block">
                <h3>Dynamic Testing</h3>
                <p>
                  OWASP ZAP and other DAST tools identify runtime vulnerabilities
                  including XSS, SQL injection, and authentication issues.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="quality-block">
                <h3>Code Review Process</h3>
                <p>
                  Peer review on all changes with merge request workflows,
                  automated checks, and senior developer approval gates.
                </p>
              </div>
            </div>
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Build With Rackner
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default SoftwareDevContent
